"use strict";

import { GET_PROJECTS_FOR_USER, GET_USERS, UPDATE_USERS } from "../../ApiEndpoints";
import apiClient from "../../utils/apiClient";

export const getUsers = (payload) => apiClient.post(GET_USERS, payload);

export const getUserById = (userId) => apiClient.get(`/api/users/${userId}`, {});

export const getProjectsForUser = (payload, config) => apiClient.post(
    GET_PROJECTS_FOR_USER,
    payload,
    config
);

export const updateUser = (payload) => apiClient.post(UPDATE_USERS, payload);
